import configuratorApi from '@/api/configurator-api'
import ordersApi from '@/api/orders-api'
import i18n from '@/libs/i18n'

// Vista y revisión de un pedido / oferta (orders/View y orders/Edit)
const state = {
  order: null,
  configurator: null,
}

const getters = {
  getOrder: state => state.order,
  getConfigurator: state => state.configurator,
}

const mutations = {
  setDetail(state, { order, configurator }) {
    state.order = order
    state.configurator = configurator || null
  },
  clear(state) {
    state.order = null
    state.configurator = null
  },
}

const notify = (commit, title, variant = 'success') => {
  commit('notifications', { title, variant }, { root: true })
  commit('setShowNotifications', true, { root: true })
}

// Ejecuta una llamada, avisa y vuelve a cargar el pedido
const run = async ({ commit, dispatch, state }, call, success) => {
  commit('app/loading', true, { root: true })
  try {
    await call()
    if (success) notify(commit, i18n.t(success))
    await dispatch('load', state.order.id)
    return true
  } catch (e) {
    const error = e.response && e.response.data && (e.response.data.error || e.response.data.message)
    notify(commit, error || i18n.t('configurator.detail.action_error'), 'danger')
    commit('app/loading', false, { root: true })
    return false
  }
}

const actions = {
  async load({ commit }, id) {
    commit('app/loading', true, { root: true })
    try {
      const response = await configuratorApi.getOffer(id)
      commit('setDetail', { order: response.data.data, configurator: response.data.configurator })
    } catch (e) {
      notify(commit, i18n.t('configurator.get_order_error'), 'danger')
    }
    commit('app/loading', false, { root: true })
  },
  changeStatus(context, { status, date = '', url = '' }) {
    return run(context, () => ordersApi.changeStatus(context.state.order.id, status, '', date, url), 'configurator.detail.status_updated')
  },
  setTransport(context, price) {
    return run(context, () => ordersApi.savePriceTransport(context.state.order.id, price), 'configurator.detail.saved')
  },
  setInstallation(context, price) {
    return run(context, () => ordersApi.savePriceInstallation(context.state.order.id, price), 'configurator.detail.saved')
  },
  setDiscount(context, percentage) {
    return run(context, () => ordersApi.savePriceDiscount(context.state.order.id, percentage), 'configurator.detail.saved')
  },
  setPackaging(context, { type, price }) {
    return run(context, () => ordersApi.savePackaging(context.state.order.id, price, type), 'configurator.detail.saved')
  },
  // Precio de una línea "a consultar" (cortina sin tarifa, cuadro o extra sin precio)
  setLinePrice(context, { line, amount }) {
    const atributos = JSON.parse(line.atributos)
    atributos.price_pending = false
    // Precio puesto a mano por Tecnitex: se puede seguir corrigiendo mientras está en revisión
    atributos.manual_price = true
    if (atributos.tipo === 'cortinas') atributos.precio = amount
    return run(context, () => ordersApi.editLine(line.id, { amount, atributos: JSON.stringify(atributos) }), 'configurator.detail.saved')
  },
  finishReview(context) {
    context.commit('app/textloading', i18n.t('configurator.detail.generating_pdf'), { root: true })
    return run(context, () => ordersApi.finishRevision(context.state.order.id), 'configurator.detail.review_finished')
      .finally(() => context.commit('app/textloading', '', { root: true }))
  },
  uploadDocuments(context, formData) {
    formData.append('order_id', context.state.order.id)
    return run(context, () => ordersApi.changeArchives(formData), 'configurator.detail.documents_uploaded')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
